import lang from "quasar/lang/es.js"
import iconSet from "quasar/icon-set/material-icons.js"
import { Notify,BottomSheet,Dialog } from "quasar"


export const componentsWithDefaults = {  }

export const appConfigKey = "nuxtQuasar"

export const quasarNuxtConfig = {
  lang,
  iconSet,
  components: {"defaults":{}},
  plugins: {Notify,BottomSheet,Dialog},
  
}